/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconMyDistrict = (props) => (
  <SVG
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_4105_7611"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="24"
      height="24"
    >
      <rect x="1" y="1" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4105_7611)">
      <path
        d="M3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H11C11.55 4 12.0208 4.19583 12.4125 4.5875C12.8042 4.97917 13 5.45 13 6V8H21C21.55 8 22.0208 8.19583 22.4125 8.5875C22.8042 8.97917 23 9.45 23 10V20C23 20.55 22.8042 21.0208 22.4125 21.4125C22.0208 21.8042 21.55 22 21 22H5C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20ZM5 20H7V18H5V20ZM5 16H7V14H5V16ZM5 12H7V10H5V12ZM5 8H7V6H5V8ZM9 20H11V18H9V20ZM9 16H11V14H9V16ZM9 12H11V10H9V12ZM9 8H11V6H9V8ZM13 20H21V10H13V12H15V14H13V16H15V18H13V20ZM17 14V12H19V14H17ZM17 18V16H19V18H17Z"
        fill="#currentColor"
      />
    </g>
  </SVG>
)

export default withIconStyles(IconMyDistrict)
